import { forwardRef, type SelectHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  hasError?: boolean
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, hasError, children, ...props },
  ref,
) {
  return (
    <select
      ref={ref}
      className={cn(
        'block w-full appearance-none rounded-md border bg-white pl-3 pr-8 h-10 text-sm text-slate-900',
        'focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-1',
        'disabled:bg-slate-100 disabled:text-slate-500',
        'dark:bg-slate-900 dark:text-slate-100 dark:disabled:bg-slate-800 dark:disabled:text-slate-500',
        hasError ? 'border-status-error' : 'border-slate-300 dark:border-slate-700',
        'bg-no-repeat bg-[length:16px_16px] bg-[right_8px_center]',
        "bg-[url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23475569' stroke-width='2'><polyline points='6 9 12 15 18 9'/></svg>\")]",
        className,
      )}
      {...props}
    >
      {children}
    </select>
  )
})
